import DEFAULT from '../index'
import { PartnerConfig } from '../../../types'
import FIELDS from '@/config/premadeConfigs/field'
import { familyMemberDateOfBirthField } from '@/config/premadeConfigs/fieldLists'

const RegressionFullConfigFlowV2 = (): PartnerConfig => ({
  branding: {
    logo: [
      {
        src: '/images/babylon.png',
        alt: 'Babylon logo',
      },
    ],
  },
  config: {
    useBrandingOnAuth0: false,
    name: 'Fast Track Regression Flow',
    appName: DEFAULT.APPNAMES.BABYLON,
    acceptLanguage: 'en-US',
    codes: {
      membership: '',
    },
    partnerUrlSlug: 'regression-full-flow-fast-track',
    isAccountCreationV2: true,
    useDnaV2Design: true,
    steps: [
      {
        slug: 'welcome-test',
        component: 'welcome',
      },
      {
        slug: 'about-you-test',
        component: 'aboutYou',
      },
      {
        slug: 'family-test',
        component: 'family',
      },
      {
        slug: 'eligibility-test',
        component: 'eligibility',
      },
      {
        slug: 'thank-you-test',
        component: 'summary',
      },
    ],
    fields: [
      [],
      [
        FIELDS.FIRST_NAME,
        FIELDS.MIDDLE_NAME,
        FIELDS.LAST_NAME,
        FIELDS.DATE_OF_BIRTH_V2,
        FIELDS.ZIPCODE_V2,
        FIELDS.PHONE_COUNTRY_CODE,
        FIELDS.PHONE_NUMBER_V2,
      ],
      [
        FIELDS.FIRST_NAME,
        FIELDS.LAST_NAME,
        {
          ...FIELDS.ZIPCODE,
          name: 'address_post_code', // Family member input accepts this instead
        },
        familyMemberDateOfBirthField,
      ],
    ],
  },
  content: {
    'en-US': {
      steps: [
        {
          title: 'Welcome to Babylon',
          stepperLabel: 'Welcome',
          copy: [
            'Get health care anytime on your phone at no cost through Babylon. Data rates may apply.',
          ],
        },
        {
          title: 'About you',
          stepperLabel: 'About you',
        },
        {
          title: 'Add Family Members',
          stepperLabel: 'Family',
          copy: [
            'Add your family members so they can have access to Babylon’s services',
          ],
        },
        {
          stepperLabel: 'Eligibility',
        },
        {
          title: 'Download the app',
          stepperLabel: 'Thank You',
          copy: [
            'Download and sign in to book a video appointment at no cost through your health plan.',
          ],
          imgUrl: '/images/babylon-ios-app.png',
          dnaV2DesignImgUrl: '/images/babylon-ios-app-us.png',
          cta: {
            showDownloadButtons: true,
            label: 'Questions? Contact us →',
            link: 'https://us-support.babylonhealth.com/hc/en-us',
          },
        },
      ],
      footerLinks: [
        {
          key: 'faqs',
          link: 'https://us-support.babylonhealth.com/hc/en-us',
        },
        {
          key: 'termsAndConditions',
          link: 'https://www.babylonhealth.com/us/tou',
        },
        {
          key: 'privacyPolicy',
          link: 'https://www.babylonhealth.com/us/privacy',
        },
      ],
    },
  },
})

export default RegressionFullConfigFlowV2
